import styled from 'styled-components'
import { useIntl } from 'react-intl'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import { LABEL_HEIGHT } from 'LuxKit/Label/constants'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useExperienceReservationExpiryTimer } from './useExperienceReservationExpiryTimer'

const TimerLabel = styled(UrgencyLabel)`
  width: fit-content;
  max-width: 100%;
  height: auto;
  min-height: ${LABEL_HEIGHT};
  white-space: normal;
  flex-wrap: wrap;
  justify-content: center;

  ${mediaQueryUp.tablet} {
    justify-content: flex-start;
  }
`

interface Props {
  reservationExpiresAt?: string
}

function ExperienceReservationExpiryTimer({ reservationExpiresAt }: Props) {
  const intl = useIntl()
  const { timeRemaining } = useExperienceReservationExpiryTimer(reservationExpiresAt)

  if (!timeRemaining) return undefined

  const formattedTimeRemaining = `${timeRemaining.minutes.toString().padStart(2, '0')}:${timeRemaining.seconds.toString().padStart(2, '0')}`

  return (
    <TimerLabel variant="critical2" icon={<LineInfoCircleIcon />}>
      {intl.formatMessage({
        id: 'ElGarKZP9yIQoHr7RCWV',
        defaultMessage: 'YOUR TICKETS ARE RESERVED FOR {timeRemaining}',
        description: 'Urgency countdown label shown on a checkout experience item while the provider ticket reservation is still active',
      }, {
        timeRemaining: formattedTimeRemaining,
      })}
    </TimerLabel>
  )
}

export default ExperienceReservationExpiryTimer
